import StoreService from './StoreService';

export default StoreService;
